<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        Employee Profile Details Request
    </div>
    <div class="card-body">
        <!-- Accordion Start -->
        <!-- Accordion Item 1 -->
        <div class="accordion">
            <div class="accordion-item">
                <input type="checkbox" id="section1" class="accordion-toggle">
                <label for="section1" class="accordion-header">
                    <i class="bi bi-person-fill"></i>&nbsp;&nbsp;Personal
                    Detail <span class="accordion-icon"><i class="bi bi-chevron-down"></i></span></label>
                <div class="accordion-content">
                    <form name="PersonalDetail" (ngSubmit)="PersonalDetail.form.valid && Save('PersonalDetail')"
                        #PersonalDetail="ngForm">
                        <div class="card" style="border-radius: 0%; border: none; border-style: none;padding: 2px;"
                            *ngIf="BasicDetail.allowEdit === '0'">
                            <span class="accordion-icon">
                                <button type="button" *ngIf="BasicDetail.allowEdit === '0'" name="personalhistory"
                                    class="btn btn-sm btn-primary" (click)="openHistory('Details')"><i
                                        class="bi bi-list-stars cursor-pointer"></i>History</button>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<small class="badge"
                                    *ngIf="BasicDetail.allowEdit === '0'"
                                    [ngClass]="{'warning':BasicDetail.allowEdit === '0'}">Pending for
                                    Approval</small></span>
                        </div>
                        <div class="card" style="border-radius: 0%;">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-4 px-1">
                                        <label>First Name<span class="text-danger">*</span></label>
                                        <input name="firstname" maxlength="100" class="form-control" placeholder="Ex."
                                            [(ngModel)]="BasicDetail.FirstName" #firstname="ngModel" required
                                            [disabled]="BasicDetail.allowEdit === '0'" maxlength="100"
                                            (keypress)="validateName($event)" (blur)="onInputChange()">
                                        <div class="invalid-feedback">
                                            Please enter First name.
                                        </div>
                                    </div>
                                    <div class="col-md-4 px-1">
                                        <label>Middle Name</label>
                                        <input name="middlename" maxlength="100" class="form-control" placeholder="Ex."
                                            [(ngModel)]="BasicDetail.MiddleName" #middlename="ngModel"
                                            [disabled]="BasicDetail.allowEdit === '0'" maxlength="100"
                                            (keypress)="validateName($event)" (blur)="onInputChange()">
                                        <div class="invalid-feedback">
                                            Please enter Middle name.
                                        </div>
                                    </div>
                                    <div class="col-md-4 px-1">
                                        <label>Last Name </label>
                                        <input name="lastname" maxlength="100" class="form-control" placeholder="Ex."
                                            [(ngModel)]="BasicDetail.LastName" #lastname="ngModel"
                                            [disabled]="BasicDetail.allowEdit === '0'" maxlength="100"
                                            (keypress)="validateName($event)" (blur)="onInputChange()">
                                        <div class="invalid-feedback">
                                            Please enter Last name.
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-4 px-1">
                                        <label>Father/Husband Name<span class="text-danger">*</span></label>
                                        <input name="fatherhusbanname" maxlength="100" class="form-control"
                                            placeholder="Ex." [(ngModel)]="BasicDetail.FatherHusbandName"
                                            #fatherhusbanname="ngModel" required
                                            [disabled]="BasicDetail.allowEdit === '0'" maxlength="200"
                                            (keypress)="validateName($event)" (blur)="onInputChange()">
                                        <div class="invalid-feedback">
                                            Please enter Father/Husband name.
                                        </div>
                                    </div>
                                    <div class="col-md-3 px-1">
                                        <label class="Label">Date Of Birth<span class="text-danger">*</span></label>
                                        <div class="input-group" style="height: auto;">
                                            <input class="form-control" name="Dateofbirth" placeholder="Ex. DD MMM YYYY"
                                                ngbDatepicker #d="ngbDatepicker" [(ngModel)]="BasicDetail.BirthDateObj"
                                                [minDate]="{ year:1930, month: 12, day: 31 }"
                                                [maxDate]="{ year: 2124, month: 12, day: 31 }" readonly required
                                                [disabled]="BasicDetail.allowEdit === '0'" />
                                            <button class="btn btn-outline-secondary bi bi-calendar3"
                                                (click)="d.toggle()" type="button"
                                                [disabled]="BasicDetail.allowEdit === '0'"></button>
                                        </div>
                                        <div class="invalid-feedback">
                                            Please select Date of birth.
                                        </div>
                                    </div>
                                    <div class="col-md-3 px-1">
                                        <label class="Label">Marital Status<span class="text-danger">*</span></label>
                                        <ng-select name="maritalstatus" [items]="Marital" bindLabel="MartialStatusName"
                                            bindValue="MartialStatusMasterID" [(ngModel)]="BasicDetail.MaritalStatusID"
                                            placeholder="Select Marital Status" required
                                            [disabled]="BasicDetail.allowEdit === '0'">
                                        </ng-select>
                                        <div class="invalid-feedback">
                                            Please select Marital status.
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <!-- <div class="col-md-3 px-1"><br>
                                        <label class="Label">Gender<span class="text-danger">*</span></label>
                                        <div class="btn-group btn-group-toggle">
                                            <label *ngFor="let gender of Gender" class="form-check-label link-dark px-2"
                                                ngbButtonLabel> {{ gender.GenderName }}
                                                <input class="form-check-input" type="radio"
                                                    [value]="gender.GenderMasterID" name="Gender"
                                                    [(ngModel)]="BasicDetail.GenderID"
                                                    [ngModelOptions]="{standalone: true}"
                                                    [disabled]="BasicDetail.allowEdit === '0'">
                                            </label>
                                        </div>
                                    </div> -->
                                    <div class="col-md-4 px-1"><br>
                                        <label class="Label">Gender<span class="text-danger">*</span></label>
                                        <div class="btn-group btn-group-toggle">
                                            <label class="form-check-label link-dark px-2" ngbButtonLabel>
                                                <input class="form-check-input" type="radio" [value]="1" name="Gender"
                                                    [(ngModel)]="BasicDetail.GenderID"
                                                    [ngModelOptions]="{standalone: true}"
                                                    [disabled]="BasicDetail.allowEdit === '0'">Male
                                            </label>
                                            <label class="form-check-label link-dark px-2" ngbButtonLabel>
                                                <input class="form-check-input" type="radio" [value]="2" name="Gender"
                                                    [(ngModel)]="BasicDetail.GenderID"
                                                    [ngModelOptions]="{standalone: true}"
                                                    [disabled]="BasicDetail.allowEdit === '0'">Female
                                            </label>
                                            <label class="form-check-label link-dark px-2" ngbButtonLabel>
                                                <input class="form-check-input" type="radio" [value]="3" name="Gender"
                                                    [(ngModel)]="BasicDetail.GenderID"
                                                    [ngModelOptions]="{standalone: true}"
                                                    [disabled]="BasicDetail.allowEdit === '0'">Others
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-md-2 px-1" *ngIf="BasicDetail.allowEdit !== '0'"><br>
                                        <button type="submit" name="PersonalDetail" class="btn btn-primary"
                                            [disabled]="isDisabled"><i class="bi bi-save2" *ngIf="!isDisabled"></i>
                                            <span class="spinner-border spinner-border-sm" role="status"
                                                aria-hidden="true" *ngIf="isDisabled"></span>
                                            {{!isDisabled?'Save':'Loading...'}}</button>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="card-footer">
                                <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                                    <button type="submit" name="PersonalDetail" class="btn btn-primary"
                                        [disabled]="isDisabled"><i class="bi bi-save2" *ngIf="!isDisabled"></i>
                                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                            *ngIf="isDisabled"></span>
                                        {{!isDisabled?'Save':'Loading...'}}</button>
                                </div>
                            </div> -->
                        </div>
                    </form>
                </div>
            </div>
            <!-- Accordion Item 2 -->
            <div class="accordion-item">
                <input type="checkbox" id="section2" class="accordion-toggle">
                <label for="section2" class="accordion-header"><i class="bi bi-geo-fill"></i>&nbsp;&nbsp;Current Address
                    <i class="bi bi-chevron-down accordion-icon"></i></label>
                <div class="accordion-content">
                    <form name="CurrentAdd" (ngSubmit)="CurrentAdd.form.valid && Save('CurrentAddress')"
                        #CurrentAdd="ngForm">
                        <div class="card" style="border-radius: 0%; border: none; border-style: none;padding: 2px;"
                            *ngIf="CurrentAddress.allowEdit === '0'">
                            <span class="accordion-icon">
                                <button type="button" name="currenthistory" class="btn btn-sm btn-primary"
                                    (click)="openHistory('CurrentAddress')"><i
                                        class="bi bi-list-stars cursor-pointer"></i>History</button>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<small class="badge"
                                    *ngIf="CurrentAddress.allowEdit === '0'"
                                    [ngClass]="{'warning':CurrentAddress.allowEdit === '0'}">Pending for
                                    Approval</small></span>
                        </div>
                        <div class="card" style="border-radius: 0%;">
                            <!-- <div class="card-header">
                                <div class="row">
                                    <div class="col"> Current Address</div>
                                    <div class="col-auto">
                                        <span> <button type="button" *ngIf="CurrentAddress.allowEdit === '0'"
                                                name="currenthistory" class="btn btn-sm btn-primary"
                                                (click)="openHistory('CurrentAddress')"><i
                                                    class="bi bi-list-stars cursor-pointer"></i>History</button></span>
                                        &nbsp; &nbsp;&nbsp;<span> <small class="badge"
                                                *ngIf="CurrentAddress.allowEdit === '0'"
                                                [ngClass]="{'warning':CurrentAddress.allowEdit === '0'}">Pending for
                                                Approval</small></span>
                                    </div>
                                </div>
                            </div>-->
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-6 px-1">
                                        <label>LocalAddress 1<span class="text-danger">*</span></label>
                                        <input type="text" name="localaddress1" class="form-control" placeholder="Ex."
                                            [(ngModel)]="CurrentAddress.LocalAddress1" #localaddress1="ngModel"
                                            [disabled]="CurrentAddress.allowEdit === '0'" required
                                            (blur)="onInputChange()">
                                        <div class="invalid-feedback">
                                            Please enter LocalAddress 1.
                                        </div>
                                    </div>
                                    <div class="col-md-6 px-1">
                                        <label>LocalAddress 2</label>
                                        <input type="text" name="localaddress2" class="form-control" placeholder="Ex."
                                            [(ngModel)]="CurrentAddress.LocalAddress2" #localaddress2="ngModel"
                                            [disabled]="CurrentAddress.allowEdit === '0'" (blur)="onInputChange()">
                                        <div class="invalid-feedback">
                                            Please enter LocalAddress 2.
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-4 px-1">
                                        <label>Village/City</label>
                                        <input type="text" name="villagecity" class="form-control" placeholder="Ex."
                                            [(ngModel)]="CurrentAddress.VillageCity" #villagecity="ngModel"
                                            [disabled]="CurrentAddress.allowEdit === '0'" (blur)="onInputChange()">
                                        <div class="invalid-feedback">
                                            Please enter Village/City.
                                        </div>
                                    </div>
                                    <div class="col-md-4 px-1">
                                        <label class="Label">State</label>
                                        <ng-select name="state" [items]="StateLoad" bindLabel="StateName"
                                            bindValue="StateMasterID" [(ngModel)]="CurrentAddress.StateID"
                                            placeholder="Select state"
                                            (change)="ComboLoad('District');onSelectChange('currentstate');"
                                            [disabled]="CurrentAddress.allowEdit === '0'">
                                        </ng-select>
                                        <div class="invalid-feedback">
                                            Please select state.
                                        </div>
                                    </div>
                                    <div class="col-md-4 px-1">
                                        <label class="Label">District</label>
                                        <ng-select name="district" [items]="DistrictLoad" bindLabel="DistrictName"
                                            bindValue="DistrictMasterID" [(ngModel)]="CurrentAddress.DistrictID"
                                            placeholder="Select district"
                                            (change)="ComboLoad('Taluka');onSelectChange('currentdistrict');"
                                            [disabled]="CurrentAddress.allowEdit === '0'">
                                        </ng-select>
                                        <div class="invalid-feedback">
                                            Please select District.
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-4 px-1">
                                        <label class="Label">Taluka</label>
                                        <ng-select name="taluka" [items]="TalukaLoad" bindLabel="TalukaName"
                                            bindValue="TalukaMasterID" [(ngModel)]="CurrentAddress.TalukaTehsilID"
                                            placeholder="Select taluka" [disabled]="CurrentAddress.allowEdit === '0'">
                                        </ng-select>
                                        <div class="invalid-feedback">
                                            Please select taluka.
                                        </div>
                                    </div>
                                    <div class="col-md-4 px-1">
                                        <label>Pincode</label>
                                        <input type="text" name="pincode5" class="form-control" placeholder="Ex."
                                            [(ngModel)]="CurrentAddress.Pincode" #pincode5="ngModel"
                                            [disabled]="CurrentAddress.allowEdit === '0'" maxlength="6"
                                            (keypress)="validatePincode($event)">
                                        <div class="invalid-feedback">
                                            Please enter Pincode.
                                        </div>
                                    </div>
                                    <div class="col-md-2 px-1" *ngIf="CurrentAddress.allowEdit !== '0'"><br>
                                        <button type="submit" name="perma" class="btn btn-primary"
                                            [disabled]="isDisabled"><i class="bi bi-save2" *ngIf="!isDisabled"></i>
                                            <span class="spinner-border spinner-border-sm" role="status"
                                                aria-hidden="true" *ngIf="isDisabled"></span>
                                            {{!isDisabled?'Save':'Loading...'}}</button>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="card-footer">
                                <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                                    <button type="submit" name="perma" class="btn btn-primary"
                                        [disabled]="isDisabled"><i class="bi bi-save2" *ngIf="!isDisabled"></i>
                                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                            *ngIf="isDisabled"></span>
                                        {{!isDisabled?'Save':'Loading...'}}</button>
                                </div>
                            </div> -->
                        </div>
                    </form>
                    <!-- <form name="PermanentAdd" (ngSubmit)="PermanentAdd.form.valid && Save('PermanentAddress')"
                        #PermanentAdd="ngForm">
                        <div class="card" style="border-radius: 0%;">
                            <div class="card-header">
                                <div class="row">
                                    <div class="col">Permanent Address</div>
                                    <div class="col-auto">
                                        <span> <button type="button" *ngIf="PermanentAddress.allowEdit === '0'"
                                                name="permanenthistory" class="btn btn-sm btn-primary"
                                                (click)="openHistory('PermanentAddress')"><i
                                                    class="bi bi-list-stars cursor-pointer"></i>History</button></span>
                                        &nbsp; &nbsp;&nbsp;<span> <small class="badge"
                                                *ngIf="PermanentAddress.allowEdit === '0'"
                                                [ngClass]="{'warning':PermanentAddress.allowEdit === '0'}">Pending for
                                                Approval</small></span>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-6 px-1">
                                        <label>NativeAddress 1<span class="text-danger">*</span></label>
                                        <input type="text" name="nativeress1" class="form-control" placeholder="Ex."
                                            [(ngModel)]="PermanentAddress.NativeAddress1" #nativeress1="ngModel"
                                            [disabled]="PermanentAddress.allowEdit === '0'" required
                                            (blur)="onInputChange()">
                                        <div class="invalid-feedback">
                                            Please enter NativeAddress 1.
                                        </div>
                                    </div>
                                    <div class="col-md-6 px-1">
                                        <label>NativeAddress 2</label>
                                        <input type="text" name="nativeress2" class="form-control" placeholder="Ex."
                                            [(ngModel)]="PermanentAddress.NativeAddress2" #nativeress2="ngModel"
                                            [disabled]="PermanentAddress.allowEdit === '0'" (blur)="onInputChange()">
                                        <div class="invalid-feedback">
                                            Please enter NativeAddress 2.
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-4 px-1">
                                        <label>Village/City</label>
                                        <input type="text" name="villagecity1" class="form-control" placeholder="Ex."
                                            [(ngModel)]="PermanentAddress.VillageCity" #villagecity1="ngModel"
                                            [disabled]="PermanentAddress.allowEdit === '0'" (blur)="onInputChange()">
                                        <div class="invalid-feedback">
                                            Please enter Village/City.
                                        </div>
                                    </div>
                                    <div class="col-md-4 px-1">
                                        <label class="Label">State</label>
                                        <ng-select name="state1" [items]="StateLoad" bindLabel="StateName"
                                            bindValue="StateMasterID" [(ngModel)]="PermanentAddress.StateID"
                                            placeholder="Select state"
                                            (change)="ComboLoad3('District');onSelectChange('permanentstate');"
                                            [disabled]="PermanentAddress.allowEdit === '0'">
                                        </ng-select>
                                        <div class="invalid-feedback">
                                            Please select state.
                                        </div>
                                    </div>
                                    <div class="col-md-4 px-1">
                                        <label class="Label">District</label>
                                        <ng-select name="district1" [items]="PermanentDistrictLoad"
                                            bindLabel="DistrictName" bindValue="DistrictMasterID"
                                            [(ngModel)]="PermanentAddress.DistrictID" placeholder="Select district"
                                            (change)="ComboLoad3('Taluka');onSelectChange('permanentdistrict');"
                                            [disabled]="PermanentAddress.allowEdit === '0'">
                                        </ng-select>
                                        <div class="invalid-feedback">
                                            Please select District.
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-4 px-1">
                                        <label class="Label">Taluka</label>
                                        <ng-select name="taluka9" [items]="PermanentTalukaLoad" bindLabel="TalukaName"
                                            bindValue="TalukaMasterID" [(ngModel)]="PermanentAddress.TalukaTehsilID"
                                            placeholder="Select taluka" [disabled]="PermanentAddress.allowEdit === '0'">
                                        </ng-select>
                                        <div class="invalid-feedback">
                                            Please select taluka.
                                        </div>
                                    </div>
                                    <div class="col-md-4 px-1">
                                        <label>Pincode</label>
                                        <input type="text" name="pincode4" class="form-control" placeholder="Ex."
                                            [(ngModel)]="PermanentAddress.Pincode" #pincode4="ngModel"
                                            [disabled]="PermanentAddress.allowEdit === '0'" maxlength="6"
                                            (keypress)="validatePincode($event)">
                                        <div class="invalid-feedback">
                                            Please enter Pincode.
                                        </div>
                                    </div>
                                    <div class="col-md-2 px-1" *ngIf="PermanentAddress.allowEdit !== '0'"><br>
                                        <button type="submit" name="curr" class="btn btn-primary"
                                            [disabled]="isDisabled"><i class="bi bi-save2" *ngIf="!isDisabled"></i>
                                            <span class="spinner-border spinner-border-sm" role="status"
                                                aria-hidden="true" *ngIf="isDisabled"></span>
                                            {{!isDisabled?'Save':'Loading...'}}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form> -->
                </div>
            </div>
            <!-- Accordation Item 8 -->
            <div class="accordion-item">
                <input type="checkbox" id="section8" class="accordion-toggle">
                <label for="section8" class="accordion-header"><i class="bi bi-building-add"></i>&nbsp;&nbsp;Permanent
                    Address
                    <i class="bi bi-chevron-down accordion-icon"></i></label>
                <div class="accordion-content">
                    <form name="PermanentAdd" (ngSubmit)="PermanentAdd.form.valid && Save('PermanentAddress')"
                        #PermanentAdd="ngForm">
                        <div class="card" style="border-radius: 0%; border: none; border-style: none;padding: 2px;"
                            *ngIf="PermanentAddress.allowEdit === '0'">
                            <span class="accordion-icon">
                                <button type="button" name="permanenthistory" class="btn btn-sm btn-primary"
                                    (click)="openHistory('PermanentAddress')"><i
                                        class="bi bi-list-stars cursor-pointer"></i>History</button>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<small class="badge"
                                    *ngIf="PermanentAddress.allowEdit === '0'"
                                    [ngClass]="{'warning':PermanentAddress.allowEdit === '0'}">Pending for
                                    Approval</small></span>
                        </div>
                        <div class="card" style="border-radius: 0%;">
                            <!-- <div class="card-header">
                                <div class="row">
                                    <div class="col">Permanent Address</div>
                                    <div class="col-auto">
                                        <span> <button type="button" *ngIf="PermanentAddress.allowEdit === '0'"
                                                name="permanenthistory" class="btn btn-sm btn-primary"
                                                (click)="openHistory('PermanentAddress')"><i
                                                    class="bi bi-list-stars cursor-pointer"></i>History</button></span>
                                        &nbsp; &nbsp;&nbsp;<span> <small class="badge"
                                                *ngIf="PermanentAddress.allowEdit === '0'"
                                                [ngClass]="{'warning':PermanentAddress.allowEdit === '0'}">Pending for
                                                Approval</small></span>
                                    </div>
                                </div>
                            </div> -->
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-6 px-1">
                                        <label>NativeAddress 1<span class="text-danger">*</span></label>
                                        <input type="text" name="nativeress1" class="form-control" placeholder="Ex."
                                            [(ngModel)]="PermanentAddress.NativeAddress1" #nativeress1="ngModel"
                                            [disabled]="PermanentAddress.allowEdit === '0'" required
                                            (blur)="onInputChange()">
                                        <div class="invalid-feedback">
                                            Please enter NativeAddress 1.
                                        </div>
                                    </div>
                                    <div class="col-md-6 px-1">
                                        <label>NativeAddress 2</label>
                                        <input type="text" name="nativeress2" class="form-control" placeholder="Ex."
                                            [(ngModel)]="PermanentAddress.NativeAddress2" #nativeress2="ngModel"
                                            [disabled]="PermanentAddress.allowEdit === '0'" (blur)="onInputChange()">
                                        <div class="invalid-feedback">
                                            Please enter NativeAddress 2.
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-4 px-1">
                                        <label>Village/City</label>
                                        <input type="text" name="villagecity1" class="form-control" placeholder="Ex."
                                            [(ngModel)]="PermanentAddress.VillageCity" #villagecity1="ngModel"
                                            [disabled]="PermanentAddress.allowEdit === '0'" (blur)="onInputChange()">
                                        <div class="invalid-feedback">
                                            Please enter Village/City.
                                        </div>
                                    </div>
                                    <div class="col-md-4 px-1">
                                        <label class="Label">State</label>
                                        <ng-select name="state1" [items]="StateLoad" bindLabel="StateName"
                                            bindValue="StateMasterID" [(ngModel)]="PermanentAddress.StateID"
                                            placeholder="Select state"
                                            (change)="ComboLoad3('District');onSelectChange('permanentstate');"
                                            [disabled]="PermanentAddress.allowEdit === '0'">
                                        </ng-select>
                                        <div class="invalid-feedback">
                                            Please select state.
                                        </div>
                                    </div>
                                    <div class="col-md-4 px-1">
                                        <label class="Label">District</label>
                                        <ng-select name="district1" [items]="PermanentDistrictLoad"
                                            bindLabel="DistrictName" bindValue="DistrictMasterID"
                                            [(ngModel)]="PermanentAddress.DistrictID" placeholder="Select district"
                                            (change)="ComboLoad3('Taluka');onSelectChange('permanentdistrict');"
                                            [disabled]="PermanentAddress.allowEdit === '0'">
                                        </ng-select>
                                        <div class="invalid-feedback">
                                            Please select District.
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-4 px-1">
                                        <label class="Label">Taluka</label>
                                        <ng-select name="taluka9" [items]="PermanentTalukaLoad" bindLabel="TalukaName"
                                            bindValue="TalukaMasterID" [(ngModel)]="PermanentAddress.TalukaTehsilID"
                                            placeholder="Select taluka" [disabled]="PermanentAddress.allowEdit === '0'">
                                        </ng-select>
                                        <div class="invalid-feedback">
                                            Please select taluka.
                                        </div>
                                    </div>
                                    <div class="col-md-4 px-1">
                                        <label>Pincode</label>
                                        <input type="text" name="pincode4" class="form-control" placeholder="Ex."
                                            [(ngModel)]="PermanentAddress.Pincode" #pincode4="ngModel"
                                            [disabled]="PermanentAddress.allowEdit === '0'" maxlength="6"
                                            (keypress)="validatePincode($event)">
                                        <div class="invalid-feedback">
                                            Please enter Pincode.
                                        </div>
                                    </div>
                                    <div class="col-md-2 px-1" *ngIf="PermanentAddress.allowEdit !== '0'"><br>
                                        <button type="submit" name="curr" class="btn btn-primary"
                                            [disabled]="isDisabled"><i class="bi bi-save2" *ngIf="!isDisabled"></i>
                                            <span class="spinner-border spinner-border-sm" role="status"
                                                aria-hidden="true" *ngIf="isDisabled"></span>
                                            {{!isDisabled?'Save':'Loading...'}}</button>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="card-footer">
                                <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                                    <button type="submit" name="curr" class="btn btn-primary" [disabled]="isDisabled"><i
                                            class="bi bi-save2" *ngIf="!isDisabled"></i>
                                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                            *ngIf="isDisabled"></span>
                                        {{!isDisabled?'Save':'Loading...'}}</button>
                                </div>
                            </div> -->
                        </div>
                    </form>
                </div>
            </div>
            <!-- Accordion Item 3 -->
            <div class="accordion-item">
                <input type="checkbox" id="section3" class="accordion-toggle">
                <label for="section3" class="accordion-header"><i class="bi bi-pen-fill"></i>&nbsp;&nbsp;Qualification
                    Detail <i class="bi bi-chevron-down accordion-icon"></i></label>
                <div class="accordion-content">
                    <form name="Qualidetail" (ngSubmit)="Qualidetail.form.valid && Save('QualificationDetail')"
                        #Qualidetail="ngForm">
                        <div class="card" style="border-radius: 0%; border: none; border-style: none;padding: 2px;"
                            *ngIf="Qualification.allowEdit === '0'">
                            <span class="accordion-icon">
                                <button type="button" *ngIf="Qualification.allowEdit === '0'"
                                    name="qualificationhistory" class="btn btn-sm btn-primary"
                                    (click)="openHistory('Qualification')"><i
                                        class="bi bi-list-stars cursor-pointer"></i>History</button>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<small class="badge"
                                    *ngIf="Qualification.allowEdit === '0'"
                                    [ngClass]="{'warning':Qualification.allowEdit === '0'}">Pending for
                                    Approval</small></span>
                        </div>
                        <div class="card" style="border-radius: 0%;">
                            <div class="card-body">
                                <div class="row" *ngIf="Qualification.allowEdit !== '0'">
                                    <div class="col-md-3 px-1">
                                        <label class="Label">Qualification <span class="text-danger">*</span></label>
                                        <ng-select name="qualification" [items]="QualificationLoad"
                                            bindLabel="QualificationName" bindValue="QualificationMasterID"
                                            [(ngModel)]="Filter.QualificationID" placeholder="Select qualification"
                                            (change)="onSelectChange('Qualification');">
                                        </ng-select>
                                        <div class="invalid-feedback">
                                            Please select qualification.
                                        </div>
                                    </div>
                                    <div class="col-md-3 px-1">
                                        <label>University Board</label>
                                        <input type="text" name="universityboard" class="form-control" placeholder="Ex."
                                            [(ngModel)]="Filter.UniversityBoard" #universityboard="ngModel"
                                            (blur)="onInputChange()">
                                        <div class="invalid-feedback">
                                            Please enter University Board.
                                        </div>
                                    </div>
                                    <div class="col-md-2 px-1">
                                        <label>Year of Passing</label>
                                        <input type="text" name="yearofpassing" class="form-control" placeholder="Ex."
                                            [(ngModel)]="Filter.YearOfPassing" #yearofpassing="ngModel" maxlength="4"
                                            (keypress)="validatePincode($event)">
                                        <div class="invalid-feedback">
                                            Please enter University Board.
                                        </div>
                                    </div>
                                    <div class="col-md-2 px-1">
                                        <label>Percentage</label>
                                        <input type="text" name="percentage" class="form-control" placeholder="Ex."
                                            [(ngModel)]="Filter.Percentage" maxlength="7" #percentage="ngModel"
                                            (keypress)="validatePercentage($event)">
                                        <div class="invalid-feedback">
                                            Please enter Percentage.
                                        </div>
                                    </div>
                                    <div class="col-md-2 px-1">
                                        <label>Grade Class</label>
                                        <input type="text" name="gradeclass" class="form-control" placeholder="Ex."
                                            [(ngModel)]="Filter.GradeClass" #gradeclass="ngModel" maxlength="5"
                                            (blur)="onInputChange()">
                                        <div class="invalid-feedback">
                                            Please enter Grade Class.
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="Qualification.allowEdit !== '0'"
                                    class="d-grid gap-2 d-md-flex justify-content-md-end" style="padding-top: 3px;">
                                    <button type="button" name="add1" class="btn btn-primary" [disabled]="isDisabled"
                                        (click)="addData('Qualification')"><i class="bi bi-plus"
                                            *ngIf="!isDisabled"></i>
                                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                            *ngIf="isDisabled"></span>
                                        {{!isDisabled?'Add':'Loading...'}}</button>
                                </div>
                                <hr *ngIf="Qualification.allowEdit !== '0'">
                                <div class="card" style="border-radius: 0%; overflow: auto;">
                                    <div class="card-header">
                                        Data
                                    </div>
                                    <div class="card-body" style="overflow: auto;">
                                        <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                                            class="customeDatatable table table-bordered" name="qu">
                                            <thead class="table-light">
                                                <tr>
                                                    <th style="display: none;">EmpQualificationDetails ID</th>
                                                    <th style="display: none;">Qualification ID</th>
                                                    <th>Qualification</th>
                                                    <th>University Board</th>
                                                    <th>Year Of Passing</th>
                                                    <th>Percentage</th>
                                                    <th>Grade Class</th>
                                                    <th *ngIf="Qualification.allowEdit !== '0'">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    *ngFor="let site of Qualification.ESS_EmpProfile_QualificationDetails; let i = index">
                                                    <td style="display: none;">{{ site['EmpQualificationDetailsID'] }}
                                                    </td>
                                                    <td style="display: none;">{{site['QualificationID']}}</td>
                                                    <td>{{site['QualificationName']}}</td>
                                                    <td>{{site['UniversityBoard']}}</td>
                                                    <td>{{site['YearOfPassing']}}</td>
                                                    <td>{{site['Percentage']}}</td>
                                                    <td>{{site['GradeClass']}}</td>
                                                    <td *ngIf="Qualification.allowEdit !== '0'"> <button type="button"
                                                            class="btn btn-sm" name="delete1" style="color: red;"
                                                            (click)="deleteRow(i,'qualification')"><i
                                                                class="bi bi-trash-fill"></i></button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="card-footer" *ngIf="Qualification.allowEdit !== '0'">
                                <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                                    <button type="submit" name="qualification" class="btn btn-primary"
                                        [disabled]="isDisabled"><i class="bi bi-save2" *ngIf="!isDisabled"></i>
                                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                            *ngIf="isDisabled"></span>
                                        {{!isDisabled?'Save':'Loading...'}}</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <!-- Accordion Item 4 -->
            <div class="accordion-item">
                <input type="checkbox" id="section4" class="accordion-toggle">
                <label for="section4" class="accordion-header"><i class="bi bi-people-fill"></i>&nbsp;&nbsp;Nominee
                    Detail <i class="bi bi-chevron-down accordion-icon"></i></label>
                <div class="accordion-content">
                    <form name="Nomineedetail" (ngSubmit)="Nomineedetail.form.valid && Save('NomineeDetail')"
                        #Nomineedetail="ngForm">
                        <div class="card" style="border-radius: 0%; border: none; border-style: none;padding: 2px;"
                            *ngIf="Nominee.allowEdit === '0'">
                            <span class="accordion-icon">
                                <button type="button" *ngIf="Nominee.allowEdit === '0'" name="nomineehistory"
                                    class="btn btn-sm btn-primary" (click)="openHistory('Nominee')"><i
                                        class="bi bi-list-stars cursor-pointer"></i>History</button>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<small class="badge"
                                    *ngIf="Nominee.allowEdit === '0'"
                                    [ngClass]="{'warning':Nominee.allowEdit === '0'}">Pending for
                                    Approval</small></span>
                        </div>
                        <div class="card" style="border-radius: 0%;">
                            <div class="card-body">
                                <div class="row" *ngIf="Nominee.allowEdit !== '0'">
                                    <div class="col-md-4 px-1">
                                        <label>Name<span class="text-danger">*</span></label>
                                        <input type="text" name="name7" maxlength="100" class="form-control"
                                            placeholder="Ex." [(ngModel)]="Filter1.Name" #name7="ngModel"
                                            maxlength="200" (keypress)="validateName($event)" (blur)="onInputChange()">
                                        <div class="invalid-feedback">
                                            Please enter Name.
                                        </div>
                                    </div>
                                    <div class="col-md-4 px-1">
                                        <label>Address1</label>
                                        <input type="text" name="Address11" class="form-control" placeholder="Ex."
                                            [(ngModel)]="Filter1.Address1" #Address11="ngModel"
                                            (blur)="onInputChange()">
                                        <div class="invalid-feedback">
                                            Please enter Address1.
                                        </div>
                                    </div>
                                    <div class="col-md-4 px-1">
                                        <label>Address2</label>
                                        <input type="text" name="Address12" class="form-control" placeholder="Ex."
                                            [(ngModel)]="Filter1.Address2" #Address12="ngModel"
                                            (blur)="onInputChange()">
                                        <div class="invalid-feedback">
                                            Please enter Address1.
                                        </div>
                                    </div>
                                </div>
                                <div class="row" *ngIf="Nominee.allowEdit !== '0'">
                                    <div class="col-md-4 px-1">
                                        <label class="Label">Relationship<span class="text-danger">*</span></label>
                                        <ng-select name="relationship" [items]="RelationshipLoad"
                                            bindLabel="RelationshipName" bindValue="RelationshipMasterID"
                                            [(ngModel)]="Filter1.RelationshipID" placeholder="Select relationship"
                                            (change)="onSelectChange('relationship');">
                                        </ng-select>
                                        <div class="invalid-feedback">
                                            Please select relationship.
                                        </div>
                                    </div>
                                    <div class="col-md-4 px-1">
                                        <label class="Label">Village/City</label>
                                        <input type="text" name="VillageCity1" class="form-control" placeholder="Ex."
                                            [(ngModel)]="Filter1.VillageCity" #VillageCity1="ngModel"
                                            (blur)="onInputChange()">
                                        <div class="invalid-feedback">
                                            Please enter Village/City.
                                        </div>
                                    </div>
                                    <div class="col-md-4 px-1">
                                        <label class="Label">State</label>
                                        <ng-select name="state1" [items]="StateLoad" bindLabel="StateName"
                                            bindValue="StateMasterID" [(ngModel)]="Filter1.StateID"
                                            placeholder="Select state"
                                            (change)="ComboLoad2('District');onSelectChange('nomineestate');">
                                        </ng-select>
                                        <div class="invalid-feedback">
                                            Please select state.
                                        </div>
                                    </div>
                                </div>
                                <div class="row" *ngIf="Nominee.allowEdit !== '0'">
                                    <div class="col-md-4 px-1">
                                        <label class="Label">District</label>
                                        <ng-select name="district1" [items]="NomineeDistrictLoad"
                                            bindLabel="DistrictName" bindValue="DistrictMasterID"
                                            [(ngModel)]="Filter1.DistrictID" placeholder="Select district"
                                            (change)="ComboLoad2('Taluka');onSelectChange('nomineedistrict');">
                                        </ng-select>
                                        <div class="invalid-feedback">
                                            Please select District.
                                        </div>
                                    </div>
                                    <div class="col-md-4 px-1">
                                        <label class="Label">Taluka</label>
                                        <ng-select name="taluka1" [items]="NomineeTalukaLoad" bindLabel="TalukaName"
                                            bindValue="TalukaMasterID" [(ngModel)]="Filter1.TalukaTehsilID"
                                            placeholder="Select taluka" (change)="onSelectChange('nomineeTaluka');">
                                        </ng-select>
                                        <div class="invalid-feedback">
                                            Please select taluka.
                                        </div>
                                    </div>
                                    <div class="col-md-2 px-1">
                                        <label>Pincode</label>
                                        <input type="text" name="pincode" maxlength="6" class="form-control"
                                            placeholder="Ex." [(ngModel)]="Filter1.PinCode" #pincode="ngModel"
                                            (keypress)="validatePincode($event)">
                                        <div class="invalid-feedback">
                                            Please enter pincode.
                                        </div>
                                    </div>
                                </div>
                                <div class="row" *ngIf="Nominee.allowEdit !== '0'">
                                    <div class="col-md-3 px-1">
                                        <label class="Label">Date Of Birth<span class="text-danger">*</span></label>
                                        <div class="input-group" style="height: auto;">
                                            <input class="form-control" name="Dateofbirth1"
                                                placeholder="Ex. DD MMM YYYY" ngbDatepicker #d1="ngbDatepicker"
                                                [(ngModel)]="Filter1.BirthDateObj"
                                                [minDate]="{ year:1930, month: 12, day: 31 }" [maxDate]=MaxDate
                                                readonly />
                                            <button class="btn btn-outline-secondary bi bi-calendar3"
                                                (click)="d1.toggle()" type="button"></button>
                                        </div>
                                        <div class="invalid-feedback">
                                            Please select Date of birth.
                                        </div>
                                    </div>
                                    <div class="col-md-2 px-1">
                                        <label>Share<span class="text-danger">*</span></label>
                                        <input type="text" name="share" maxlength="7" class="form-control"
                                            placeholder="Ex." [(ngModel)]="Filter1.Share" #share="ngModel"
                                            (keypress)="validateShare($event)" (blur)="onBlurShare()">
                                        <div class="invalid-feedback">
                                            Please enter share.
                                        </div>
                                    </div>
                                    <div class="col-md-4 px-1">
                                        <label>Guardian Name</label>
                                        <input type="text" name="guardian" class="form-control" placeholder="Ex."
                                            [(ngModel)]="Filter1.Guardian" #guardian="ngModel" maxlength="200"
                                            (keypress)="validateName($event)" (blur)="onInputChange()">
                                        <div class="invalid-feedback">
                                            Please enter guardian.
                                        </div>
                                    </div>
                                    <div class="col-md-2 px-1" *ngIf="Nominee.allowEdit !== '0'"><br>
                                        <button type="button" name="add2" class="btn btn-primary"
                                            [disabled]="isDisabled" (click)="addData('Nominee')"><i class="bi bi-plus"
                                                *ngIf="!isDisabled"></i>
                                            <span class="spinner-border spinner-border-sm" role="status"
                                                aria-hidden="true" *ngIf="isDisabled"></span>
                                            {{!isDisabled?'Add':'Loading...'}}</button>
                                    </div>
                                </div>
                                <hr *ngIf="Nominee.allowEdit !== '0'">
                                <div class="card" name="nominee2" style="border-radius: 0%; overflow: auto;">
                                    <div class="card-header">
                                        Data
                                    </div>
                                    <div class="card-body" style="overflow: auto;">
                                        <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                                            class="customeDatatable table table-bordered" name="qu">
                                            <thead class="table-light">
                                                <tr>
                                                    <th style="display: none;">EmpNomineeDetails ID</th>
                                                    <th>Name</th>
                                                    <th>Address1</th>
                                                    <th>Address2</th>
                                                    <th style="display: none;">RelationshipID</th>
                                                    <th>Relationship</th>
                                                    <th>Village/City</th>
                                                    <th style="display: none;">State ID</th>
                                                    <th>State Name</th>
                                                    <th style="display: none;">District ID</th>
                                                    <th>District Name</th>
                                                    <th style="display: none;">Taluka/Tehsil ID</th>
                                                    <th>Taluka/Tehsil</th>
                                                    <th>PinCode</th>
                                                    <th>BirthDate</th>
                                                    <th>Share</th>
                                                    <th>Guardian</th>
                                                    <th *ngIf="Nominee.allowEdit !== '0'">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    *ngFor="let site of Nominee.ESS_EmpProfile_NomineeDetails; let i = index">
                                                    <td style="display: none;">{{ site['EmpNomineeDetailsID'] }}
                                                    </td>
                                                    <td>{{site['Name']}}</td>
                                                    <td>{{site['Address1']}}</td>
                                                    <td>{{site['Address2']}}</td>
                                                    <td style="display: none;">{{site['RelationshipID']}}</td>
                                                    <td>{{site['Relationship']}}</td>
                                                    <td>{{site['VillageCity']}}</td>
                                                    <td style="display: none;">{{site['StateID']}}</td>
                                                    <td>{{site['State']}}</td>
                                                    <td style="display: none;">{{site['DistrictID']}}</td>
                                                    <td>{{site['District']}}</td>
                                                    <td style="display: none;">{{site['TalukaTehsilID']}}</td>
                                                    <td>{{site['Taluka']}}</td>
                                                    <td>{{site['PinCode']}}</td>
                                                    <td>{{site['BirthDate']}}</td>
                                                    <td>{{site['Share']}}</td>
                                                    <td>{{site['Guardian']}}</td>
                                                    <td *ngIf="Nominee.allowEdit !== '0'"> <button type="button"
                                                            class="btn btn-sm" name="delete1" style="color: red;"
                                                            (click)="deleteRow(i,'nominee')"><i
                                                                class="bi bi-trash-fill"></i></button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="card-footer" *ngIf="Nominee.allowEdit !== '0'">
                                <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                                    <button type="submit" name="nominee" class="btn btn-primary"
                                        [disabled]="isDisabled"><i class="bi bi-save2" *ngIf="!isDisabled"></i>
                                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                            *ngIf="isDisabled"></span>
                                        {{!isDisabled?'Save':'Loading...'}}</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <!-- Accordion Item 5 -->
            <div class="accordion-item">
                <input type="checkbox" id="section5" class="accordion-toggle">
                <label for="section5" class="accordion-header"><i class="bi bi-person-lines-fill"></i>&nbsp;&nbsp;Family
                    Member
                    Detail <i class="bi bi-chevron-down accordion-icon"></i></label>
                <div class="accordion-content">
                    <form name="Memberdetail" (ngSubmit)="Memberdetail.form.valid && Save('MemberDetail')"
                        #Memberdetail="ngForm">
                        <div class="card" style="border-radius: 0%; border: none; border-style: none;padding: 2px;"
                            *ngIf="Dependent.allowEdit === '0'">
                            <span class="accordion-icon">
                                <button type="button" *ngIf="Dependent.allowEdit === '0'" name="dependenthistory"
                                    class="btn btn-sm btn-primary" (click)="openHistory('Dependent')"><i
                                        class="bi bi-list-stars cursor-pointer"></i>History</button>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<small class="badge"
                                    *ngIf="Dependent.allowEdit === '0'"
                                    [ngClass]="{'warning':Dependent.allowEdit === '0'}">Pending for
                                    Approval</small></span>
                        </div>
                        <div class="card" style="border-radius: 0%;">
                            <div class="card-body">
                                <div class="row" *ngIf="Dependent.allowEdit !== '0'">
                                    <div class="col-md-3 px-1">
                                        <label>Name<span class="text-danger">*</span></label>
                                        <input type="text" name="name3" class="form-control" placeholder="Ex."
                                            [(ngModel)]="Filter3.Name" #name3="ngModel" maxlength="200"
                                            (keypress)="validateName($event)" (blur)="onInputChange()">
                                        <div class="invalid-feedback">
                                            Please enter name.
                                        </div>
                                    </div>
                                    <div class="col-md-3 px-1">
                                        <label class="Label">Address Type</label>
                                        <ng-select name="addresstype" [items]="AddressTypeLoad"
                                            bindLabel="AddressTypeName" bindValue="AddressTypeMasterID"
                                            [(ngModel)]="Filter3.AddressTypeID" placeholder="Select address type"
                                            (change)="onSelectChange('addresstype');">
                                        </ng-select>
                                        <div class="invalid-feedback">
                                            Please select Address Type.
                                        </div>
                                    </div>
                                    <div class="col-md-3 px-1">
                                        <label class="Label">Date Of Birth</label>
                                        <div class="input-group" style="height: auto;">
                                            <input class="form-control" name="Dateofbirth1"
                                                placeholder="Ex. DD MMM YYYY" ngbDatepicker #d2="ngbDatepicker"
                                                [(ngModel)]="Filter3.DateOfBirthObj"
                                                [minDate]="{ year:1930, month: 12, day: 31 }" [maxDate]=MaxDate
                                                readonly />
                                            <button class="btn btn-outline-secondary bi bi-calendar3"
                                                (click)="d2.toggle()" type="button"></button>
                                        </div>
                                        <div class="invalid-feedback">
                                            Please select Date of birth.
                                        </div>
                                    </div>
                                    <div class="col-md-3 px-1">
                                        <label class="Label">Relationship<span class="text-danger">*</span></label>
                                        <ng-select name="relationship2" [items]="RelationshipLoad"
                                            bindLabel="RelationshipName" bindValue="RelationshipMasterID"
                                            [(ngModel)]="Filter3.RelationshipID" placeholder="Select relationship"
                                            (change)="onSelectChange('dependentrelationship');">
                                        </ng-select>
                                        <div class="invalid-feedback">
                                            Please select relationship.
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="Dependent.allowEdit !== '0'"
                                    class="d-grid gap-2 d-md-flex justify-content-md-end" style="padding-top: 3px;">
                                    <button type="button" name="add1" class="btn btn-primary" [disabled]="isDisabled"
                                        (click)="addData('Dependent')"><i class="bi bi-plus" *ngIf="!isDisabled"></i>
                                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                            *ngIf="isDisabled"></span>
                                        {{!isDisabled?'Add':'Loading...'}}</button>
                                </div>
                                <hr *ngIf="Dependent.allowEdit !== '0'">
                                <div class="card" style="border-radius: 0%; overflow: auto;">
                                    <div class="card-header">
                                        Data
                                    </div>
                                    <div class="card-body" style="overflow: auto;">
                                        <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                                            class="customeDatatable table table-bordered" name="depend">
                                            <thead class="table-light">
                                                <tr>
                                                    <th style="display: none;">EmpDependentDetails ID</th>
                                                    <th>Name</th>
                                                    <th style="display: none;">AddressType ID</th>
                                                    <th>Address Type</th>
                                                    <th>Date Of Birth</th>
                                                    <th style="display: none;">Relationship ID</th>
                                                    <th>Relationship</th>
                                                    <th *ngIf="Dependent.allowEdit !== '0'">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    *ngFor="let site of Dependent.ESS_EmpProfile_DependentDetails; let i = index">
                                                    <td style="display: none;">{{ site['EmpDependentDetailsID'] }}
                                                    </td>
                                                    <td>{{site['Name']}}</td>
                                                    <td style="display: none;">{{site['AddressTypeID']}}</td>
                                                    <td>{{site['AddressTypeName']}}</td>
                                                    <td>{{site['DateOfBirth']}}</td>
                                                    <td style="display: none;">{{site['RelationshipID']}}</td>
                                                    <td>{{site['Relationship']}}</td>
                                                    <td *ngIf="Dependent.allowEdit !== '0'"> <button type="button"
                                                            class="btn btn-sm" name="delete1" style="color: red;"
                                                            (click)="deleteRow(i,'Dependent')"><i
                                                                class="bi bi-trash-fill"></i></button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="Dependent.allowEdit !== '0'" class="card-footer">
                                <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                                    <button type="submit" name="member" class="btn btn-primary"
                                        [disabled]="isDisabled"><i class="bi bi-save2" *ngIf="!isDisabled"></i>
                                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                            *ngIf="isDisabled"></span>
                                        {{!isDisabled?'Save':'Loading...'}}</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <!-- Accordion Item 6 -->
            <div class="accordion-item">
                <input type="checkbox" id="section6" class="accordion-toggle">
                <label for="section6" class="accordion-header"><i
                        class="bi bi-file-earmark-person"></i>&nbsp;&nbsp;Document<i
                        class="bi bi-chevron-down accordion-icon"></i>
                </label>
                <div class="accordion-content">
                    <form name="Documentdetail" (ngSubmit)="Documentdetail.form.valid && Save('DocumentDetail')"
                        #Documentdetail="ngForm">
                        <div class="card" style="border-radius: 0%; border: none; border-style: none;padding: 2px;"
                            *ngIf="Document.allowEdit === '0'">
                            <span class="accordion-icon">
                                <button type="button" *ngIf="Document.allowEdit === '0'" name="documenthistory"
                                    class="btn btn-sm btn-primary" (click)="openHistory('Document')"><i
                                        class="bi bi-list-stars cursor-pointer"></i>History</button>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<small class="badge"
                                    *ngIf="Document.allowEdit === '0'"
                                    [ngClass]="{'warning':Document.allowEdit === '0'}">Pending for
                                    Approval</small></span>
                        </div>
                        <div class="card" style="border-radius: 0%;">
                            <div class="card-body">
                                <div class="card" style="border-radius: 0%; overflow: auto;">
                                    <div class="card-header">
                                        Data
                                    </div>
                                    <div class="card-body" style="overflow: auto;">
                                        <!-- <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
                                            class="table table-bordered overflow-auto d-table" name="doc">
                                            <thead class="table-light">
                                                <tr>
                                                    <th style="width: 5px;">#</th>
                                                    <th scope="col" style="width: 5px;">
                                                        <input type="checkbox" name="all" (change)="selectAll($event)">
                                                    </th>
                                                    <th>Document Name</th>
                                                    <th>Document Number</th>
                                                    <th style="width: 8px;">File</th>
                                                    <th style="width: 200px;" *ngIf="Document.allowEdit !== '0'"
                                                        class="text-center">Upload
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let site of DocumentLoad; let i = index">
                                                    <td style="width: 5px;">{{i + 1}}</td>
                                                    <td>
                                                        <input type="checkbox" [(ngModel)]="site.selected"
                                                            name="row{{i}}" (change)="selectRow($event, site)">
                                                    </td>
                                                    <td>{{ site['DocumentName'] }}</td>
                                                    <td style="width: 200px;">
                                                        <input name="latitude{{i}}" *ngIf="Document.allowEdit !== '0'"
                                                            type="text" [(ngModel)]="site['DocumentNumber']"
                                                            [maxlength]="site['DocumentLength'] !== '0' ? site['DocumentLength'] : null"
                                                            class="form-control form-control-sm">
                                                        <span *ngIf="Document.allowEdit === '0'">{{
                                                            site['DocumentNumber'] }}</span>
                                                    </td>
                                                    <td style="width: 8px;">
                                                        <div class="text-center">
                                                            <i *ngIf="site['FileNamelink'] !== ''"
                                                                (click)="viewFileLink(site['FileNamelink'])"
                                                                class="bi bi-filetype-doc cursor-pointer fw-bold btn-outline-primary"
                                                                style="color: blue;"></i>
                                                        </div>
                                                    </td>
                                                    <td style="width: 200px;" *ngIf="Document.allowEdit !== '0'"
                                                        class="text-center">
                                                        <div class="text-center">
                                                            <div class="file-input-container">
                                                                <input class="form-control form-control-sm"
                                                                    id="formFileSm{{i}}" type="file"
                                                                    *ngIf="!site.Attachment" name="up{{i}}"
                                                                    (change)="onFileSelected($event, site)"
                                                                    accept=".pdf,image/*" style="display: none;" />

                                                                <button class="btn btn-sm" *ngIf="!site.Attachment"
                                                                    type="button" style="color: blue;"
                                                                    (click)="triggerFileInput(i)">
                                                                    <i class="bi bi-upload"></i>
                                                                </button>
                                                                <span *ngIf="site.Attachment" class="file-name">{{
                                                                    site.Attachment }}</span>
                                                                <span *ngIf="site.Attachment">
                                                                    <button class="btn btn-sm" name="view" type="button"
                                                                        style="color: blue;" (click)="viewFile(site)">
                                                                        <i class="bi bi-eye"></i>
                                                                    </button>
                                                                </span>
                                                                <button class="btn btn-sm" name="delete" type="button"
                                                                    *ngIf="site.Attachment" (click)="removeFile(site)">
                                                                    <i class="bi bi-trash"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table> -->
                                        <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                                            class="customeDatatable table table-bordered" name="doc">
                                            <thead class="table-light">
                                                <tr>
                                                    <th style="width: 5px;">#</th>
                                                    <th scope="col" style="width: 5px;"
                                                        *ngIf="Document.allowEdit !== '0'">
                                                        <input type="checkbox" name="all" (change)="selectAll($event)">
                                                    </th>
                                                    <th>Document Name</th>
                                                    <th>Document Number</th>
                                                    <th style="width: 8px;" *ngIf="Document.allowEdit === '0'">File</th>
                                                    <th style="width: 350px;" *ngIf="Document.allowEdit !== '0'"
                                                        class="text-center">Upload
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let site of DocumentLoad; let i = index">
                                                    <td style="width: 5px;">{{i + 1}}</td>
                                                    <td *ngIf="Document.allowEdit !== '0'">
                                                        <input type="checkbox" [(ngModel)]="site.selected"
                                                            name="row{{i}}" (change)="selectRow($event, site)">
                                                    </td>
                                                    <td>{{ site['DocumentName'] }}</td>
                                                    <td style="width: 200px;">
                                                        <input name="latitude{{i}}" *ngIf="Document.allowEdit !== '0'"
                                                            type="text" [(ngModel)]="site['DocumentNumber']"
                                                            [maxlength]="site['DocumentLength'] !== '0' ? site['DocumentLength'] : null"
                                                            class="form-control form-control-sm">
                                                        <span *ngIf="Document.allowEdit === '0'">{{
                                                            site['DocumentNumber'] }}</span>
                                                    </td>
                                                    <td style="width: 8px;" *ngIf="Document.allowEdit === '0'">
                                                        <div class="text-center">
                                                            <i *ngIf="site['FileNamelink'] !== ''"
                                                                (click)="viewFileLink(site['FileNamelink'])"
                                                                class="bi bi-filetype-doc cursor-pointer fw-bold btn-outline-primary"
                                                                style="color: blue;"></i>
                                                        </div>
                                                    </td>
                                                    <td style="width: 350px;" *ngIf="Document.allowEdit !== '0'"
                                                        class="text-center">
                                                        <div class="text-center">
                                                            <div class="file-input-container">
                                                                <input class="form-control form-control-sm"
                                                                    id="formFileSm{{i}}" type="file"
                                                                    *ngIf="!site.FileName" name="up{{i}}"
                                                                    (change)="onFileSelected($event, site)"
                                                                    accept=".pdf,image/*" style="display: none;" />

                                                                <button class="btn btn-sm" *ngIf="!site.FileName"
                                                                    type="button" style="color: blue;"
                                                                    (click)="triggerFileInput(i)">
                                                                    <i class="bi bi-upload"></i>
                                                                </button>
                                                                <span *ngIf="site.FileName" class="file-name">{{
                                                                    site.FileName }}</span>
                                                                <span *ngIf="site.FileName">
                                                                    <button class="btn btn-sm" name="view" type="button"
                                                                        style="color: blue;" (click)="viewFile(site)">
                                                                        <i class="bi bi-eye"></i>
                                                                    </button>
                                                                </span>
                                                                <button class="btn btn-sm" name="delete" type="button"
                                                                    *ngIf="site.FileName" (click)="removeFile(site)">
                                                                    <i class="bi bi-trash"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="card-footer" *ngIf="Document.allowEdit !== '0'">
                                <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                                    <button type="submit" name="document" class="btn btn-primary"
                                        [disabled]="isDisabled"><i class="bi bi-save2" *ngIf="!isDisabled"></i>
                                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                            *ngIf="isDisabled"></span>
                                        {{!isDisabled?'Save':'Loading...'}}</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <!-- Accordion Item 7 -->
            <div class="accordion-item">
                <input type="checkbox" id="section7" class="accordion-toggle">
                <label for="section7" class="accordion-header"><i class="bi bi-currency-rupee"></i>&nbsp;&nbsp;Bank
                    Detail<i class="bi bi-chevron-down accordion-icon"></i>
                </label>
                <div class="accordion-content">
                    <form name="BankDetail" (ngSubmit)="BankDetail.form.valid && Save('BankDetail')"
                        #BankDetail="ngForm">
                        <div class="card" style="border-radius: 0%; border: none; border-style: none;padding: 2px;"
                            *ngIf="BankFormDetail.allowEdit === '0'">
                            <span class="accordion-icon">
                                <button type="button" *ngIf="BankFormDetail.allowEdit === '0'" name="bankhistory"
                                    class="btn btn-sm btn-primary" (click)="openHistory('Bank')"><i
                                        class="bi bi-list-stars cursor-pointer"></i>History</button>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<small class="badge"
                                    *ngIf="BankFormDetail.allowEdit === '0'"
                                    [ngClass]="{'warning':BankFormDetail.allowEdit === '0'}">Pending for
                                    Approval</small></span>
                        </div>
                        <div class="card" style="border-radius: 0%;">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-4 px-1">
                                        <label class="Label">Payment Mode <span class="text-danger">*</span></label>
                                        <ng-select name="paymentmode" [items]="PaymentModes" bindLabel="PaymentModeName"
                                            bindValue="PaymentModeMasterID" [(ngModel)]="BankFormDetail.PaymentMode"
                                            placeholder="Select payment mode"
                                            [disabled]="BankFormDetail.allowEdit ==='0'" required>
                                        </ng-select>
                                        <div class="invalid-feedback">
                                            Please select Payment Mode.
                                        </div>
                                    </div>
                                    <div class="col-md-4 px-1" *ngIf="BankFormDetail.PaymentMode !== 1">
                                        <label class="Label">Bank <span class="text-danger">*</span> </label>
                                        <ng-select name="bankid" [items]="Bank" bindLabel="bank_name"
                                            bindValue="bank_master_id" [(ngModel)]="BankFormDetail.BankID"
                                            placeholder="Select Bank"
                                            (change)="ComboLoad('BankBranch');onSelectChange('Bank');"
                                            [disabled]="BankFormDetail.allowEdit ==='0'" required>
                                        </ng-select>
                                        <div class="invalid-feedback">
                                            Please select Bank.
                                        </div>
                                    </div>
                                    <div class="col-md-4 px-1" *ngIf="BankFormDetail.PaymentMode !== 1">
                                        <label class="Label">Bank Branch <span class="text-danger">*</span> </label>
                                        <ng-select name="bankbranch" [items]="BankBranch" bindLabel="BankBranchName"
                                            bindValue="BankBranchMasterID" [(ngModel)]="BankFormDetail.BankBranchID"
                                            placeholder="Select Bank branch" (change)="onSelectChange('BankBranch');"
                                            [disabled]="BankFormDetail.allowEdit ==='0'" required>
                                        </ng-select>
                                        <div class="invalid-feedback">
                                            Please select Bank branch.
                                        </div>
                                    </div>
                                    <div class="col-md-2 px-1" *ngIf="BankFormDetail.PaymentMode !== 1">
                                        <label>IFSC Code<span class="text-danger">*</span></label>
                                        <input type="text" name="bankifsc" class="form-control" placeholder="Ex."
                                            [(ngModel)]="BankFormDetail.IFSCcode" #bankifsc="ngModel" maxlength="200"
                                            disabled>
                                        <div class="invalid-feedback">
                                            Please enter IFSC Code.
                                        </div>
                                    </div>
                                    <div class="col-md-4 px-1" *ngIf="BankFormDetail.PaymentMode !== 1">
                                        <label>Bank Account No.<span class="text-danger">*</span></label>
                                        <input type="password" name="bankaccontno"
                                            [maxlength]="acNoLength === 0 ? null : acNoLength" class="form-control"
                                            placeholder="Ex." [(ngModel)]="BankFormDetail.BankAccountNo"
                                            #bankaccontno="ngModel" [disabled]="BankFormDetail.allowEdit ==='0'"
                                            required autocomplete="new-password" (keypress)="validatePincode($event)"
                                            (paste)="onPaste($event)">
                                        <div class="invalid-feedback">
                                            Please enter Bank Account No.
                                        </div>
                                    </div>
                                    <div class="col-md-4 px-1" *ngIf="BankFormDetail.PaymentMode !== 1">
                                        <label>Confirm Bank Account No.<span class="text-danger">*</span></label>
                                        <input type="text" name="confirmbankaccontno" maxlength="50"
                                            class="form-control" placeholder="Ex."
                                            [maxlength]="acNoLength === 0 ? null : acNoLength"
                                            [(ngModel)]="ConfirmBankAccountNo" #confirmbankaccontno="ngModel"
                                            [disabled]="BankFormDetail.allowEdit ==='0'" required maxlength="50"
                                            (keypress)="validatePincode($event)" (paste)="onPaste($event)">
                                        <div class="invalid-feedback">
                                            Please enter confirm Bank Account No.
                                        </div>
                                    </div>
                                    <div class="col-md-2 px-1" *ngIf="BankFormDetail.allowEdit !=='0'"><br>
                                        <button type="submit" name="bank" class="btn btn-primary"
                                            [disabled]="isDisabled"><i class="bi bi-save2" *ngIf="!isDisabled"></i>
                                            <span class="spinner-border spinner-border-sm" role="status"
                                                aria-hidden="true" *ngIf="isDisabled"></span>
                                            {{!isDisabled?'Save':'Loading...'}}</button>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="card-footer">
                                <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                                    <button type="submit" name="bank" class="btn btn-primary" [disabled]="isDisabled"><i
                                            class="bi bi-save2" *ngIf="!isDisabled"></i>
                                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                            *ngIf="isDisabled"></span>
                                        {{!isDisabled?'Save':'Loading...'}}</button>
                                </div>
                            </div> -->
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <!-- Accordion End -->
    </div>
    <!-- <div class="card-footer">
        <div class="d-grid gap-2 d-md-flex justify-content-md-end">
            
        </div>
    </div> -->
</div>